import React from 'react';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import gravatarUrl from '@afosto/utils/gravatarUrl';

export const userFormatter = (cell, row) => (
  <>
    <Typography variant="subtitle1">
      {row?.user?.first_name} {row?.user?.last_name}
    </Typography>
  </>
);

export const avatarFormatter = (cell, row) => (
  <Avatar
    src={gravatarUrl(row?.user?.email, {
      letterValue: `${row?.user?.first_name} ${row?.user?.last_name}`,
    })}
  />
);
